import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PageHeader, useCkInside } from '@NP-Webber/crm-kit/dist/next/index.js';

/**
 * AdminPageHeader — the title row of an admin screen in both designs.
 *   new design:  crm-kit/next PageHeader (title, sub line, actions on the left, "⋮" more menu, one primary action)
 *   old design:  the classic MUI title row (h5 + the same actions)
 *
 * title, sub          text (or nodes)
 * actions             the screen's own buttons — kept as they are (themed by the new design's MUI bridge)
 * primary             { label, icon, onClick } — the one primary action (new design: ck primary button)
 * more                Menu items for the "⋮" overflow (new design only; old design shows them as actions too)
 * back                { label, onClick } — a "חזרה" link above the title (cards)
 */
export default function AdminPageHeader({ title, sub, actions, primary, more = [], menus = [], back, legacy }) {
  const inside = useCkInside();
  if (inside) {
    return (
      <>
        {back ? (
          <button type="button" className="adm-back" onClick={back.onClick}>
            <span aria-hidden="true">→</span>
            {back.label || 'חזרה'}
          </button>
        ) : null}
        <PageHeader title={title} sub={sub} primary={primary} more={more} menus={menus}>
          {actions}
        </PageHeader>
      </>
    );
  }
  if (legacy) return legacy;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 2 }}>
      <Box>
        {back ? (
          <Typography component="button" variant="body2" onClick={back.onClick} sx={{ border: 0, background: 'none', p: 0, cursor: 'pointer', color: 'primary.main', mb: 0.5 }}>
            → {back.label || 'חזרה'}
          </Typography>
        ) : null}
        <Typography variant="h5" fontWeight={700}>{title}</Typography>
        {sub ? <Typography variant="body2" color="text.secondary">{sub}</Typography> : null}
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        {actions}
        {more.filter((m) => m && !m.divider && !m.title).map((m) => (
          <Typography key={m.key} component="button" variant="body2" onClick={m.onClick} sx={{ border: 0, background: 'none', cursor: 'pointer', color: 'primary.main' }}>
            {m.label}
          </Typography>
        ))}
        {primary ? <Button variant="contained" onClick={primary.onClick}>{primary.label}</Button> : null}
      </Box>
    </Box>
  );
}
